import { Custom } from '@authFlow/utils/authFlowFlags';

export const toolkitRedirects = {
  [Custom.seoToolkit]: {
    default: {
      trial: '/seo/',
      free: '/seo/',
    },
  },
  [Custom.trafficToolkit]: {
    domain: {
      trial: '/analytics/traffic/traffic-overview/',
      free: '/analytics/traffic/traffic-overview/',
    },
    keywords: {
      trial: '/analytics/traffic/',
      free: '/analytics/traffic/',
    },
    default: {
      trial: '/analytics/traffic/',
      free: '/analytics/traffic/',
    },
  },
  [Custom.localToolkit]: {
    domain: {
      trial: {
        pro: '/local-business/start/',
        base: '/gbp-ai-agent/start/',
      },
      free: '/local-business/start/',
    },
    keywords: {
      trial: {
        pro: '/local-business/start/',
        base: '/gbp-ai-agent/start/',
      },
      free: '/local-business/start/',
    },
    default: {
      trial: {
        pro: '/local-business/start/',
        base: '/gbp-ai-agent/start/',
      },
      free: '/local-business/start/',
    },
  },
  [Custom.socialToolkit]: {
    domain: {
      trial: {
        base: '/social-media/setup',
        business: '/influencer-analytics/#social_business_open',
      },
      free: '/social-media',
    },
    keywords: {
      trial: {
        base: '/social-media/setup',
        business: '/influencer-analytics/#social_business_open',
      },
      free: '/social-media',
    },
    default: {
      trial: {
        base: '/social-media/setup',
        business: '/influencer-analytics/#social_business_open',
      },
      free: '/social-media',
    },
  },
  [Custom.contentToolkit]: {
    domain: {
      trial: '/content/',
      free: '/content/',
    },
    keywords: {
      trial: '/content/',
      free: '/content/',
    },
    default: {
      trial: '/content/',
      free: '/content/',
    },
  },
  [Custom.advertisingToolkit]: {
    domain: {
      trial: '/advertising/',
      free: '/advertising/',
    },
    keywords: {
      trial: '/advertising/',
      free: '/advertising/',
    },
    default: {
      trial: '/advertising/',
      free: '/advertising/',
    },
  },
  [Custom.aiToolkit]: {
    domain: {
      free: '/ai-seo/overview/',
    },
    keywords: {
      free: '/ai-seo/overview/',
    },
    default: {
      free: '/ai-seo/overview/',
    },
  },
  [Custom.prToolkit]: {
    domain: {
      trial: '/pr-toolkit/',
      free: '/pr-toolkit/',
    },
    keywords: {
      trial: '/pr-toolkit/',
      free: '/pr-toolkit/',
    },
    default: {
      trial: '/pr-toolkit/',
      free: '/pr-toolkit/',
    },
  },
  ['no-toolkit']: {
    default: {
      trial: '/seo/',
      free: '/seo/',
    },
  },
};
